"use client";

import { useState } from "react";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { SimpleButton } from "../../components/button.jsx/Btn";
import { ImageModal } from "../../components/modal";
import handGesture from "../../assets/hand-gesture.png";

export default function OrgChartBuilder() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [levels, setLevels] = useState([
    {
      id: "1",
      name: "Top Level",
      description: "(Executive)",
      employees: [{ id: "1", name: "", title: "" }],
    },
    {
      id: "2",
      name: "Second Level",
      description: "(Add members under top level)",
      employees: [
        { id: "1", name: "", title: "" },
        { id: "2", name: "", title: "" },
      ],
    },
  ]);

  const addEmployee = (levelId) => {
    setLevels(
      levels.map((level) =>
        level.id === levelId
          ? {
              ...level,
              employees: [
                ...level.employees,
                { id: Date.now().toString(), name: "", title: "" },
              ],
            }
          : level
      )
    );
  };

  const removeEmployee = (levelId, employeeId) => {
    setLevels(
      levels.map((level) =>
        level.id === levelId
          ? {
              ...level,
              employees: level.employees.filter((emp) => emp.id !== employeeId),
            }
          : level
      )
    );
  };

  const updateEmployee = (levelId, employeeId, field, value) => {
    setLevels(
      levels.map((level) =>
        level.id === levelId
          ? {
              ...level,
              employees: level.employees.map((emp) =>
                emp.id === employeeId ? { ...emp, [field]: value } : emp
              ),
            }
          : level
      )
    );
  };

  const addNewLevel = () => {
    const newLevel = {
      id: Date.now().toString(),
      name: `Level ${levels.length + 1}`,
      description: "(Add members)",
      employees: [{ id: "1", name: "", title: "" }],
    };
    setLevels([...levels, newLevel]);
  };

  const handleCreateChart = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="max-w-8xl rounded-xl font-Outfit  mx-auto p-6 bg-white min-h-screen">
      <div className="space-y-10 max-w-2xl">
        {levels.map((level, levelIndex) => (
          <div
            key={level.id}
            className="space-y-4"
          >
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-medium text-gray-900">
                {level.name}
              </h2>
              <span className="text-sm text-black">{level.description}</span>
              {levelIndex > 0 && (
                <div className="w-6 h-6 bg-gray-800 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs font-bold">
                    {levelIndex + 1}
                  </span>
                </div>
              )}
            </div>

            <div className="space-y-6">
              {level.employees.map((employee, employeeIndex) => (
                <div
                  key={employee.id}
                  className="space-y-2"
                >
                  <div className="text-sm text-gray-600 font-medium">
                    Choose Employee
                  </div>
                  <div className="flex items-center gap-2">
                    <select
                      className="flex-1 px-4 py-4 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      value={employee.name}
                      onChange={(e) =>
                        updateEmployee(
                          level.id,
                          employee.id,
                          "name",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select employee...</option>
                      <option value="John Doe">John Doe</option>
                      <option value="Jane Smith">Jane Smith</option>
                      <option value="Mike Johnson">Mike Johnson</option>
                    </select>
                    {level.employees.length > 1 && (
                      <div className=" flex">
                        <button
                          onClick={() => addEmployee(level.id)}
                          className="flex items-center gap-2 text-pink-500 hover:text-pink-700 transition-colors"
                        >
                          <FiPlus size={16} />
                        </button>
                        <button
                          onClick={() => removeEmployee(level.id, employee.id)}
                          className="p-2 text-pink-500 hover:text-pink-700 hover:bg-pink-50 rounded-md transition-colors"
                        >
                          <FiTrash2 size={16} />
                        </button>
                      </div>
                    )}
                  </div>

                  {/* <input
                    type="text"
                    placeholder="Title"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    value={employee.title}
                    onChange={(e) =>
                      updateEmployee(
                        level.id,
                        employee.id,
                        "title",
                        e.target.value
                      )
                    }
                  /> */}
                </div>
              ))}
            </div>
          </div>
        ))}

        <button
          onClick={addNewLevel}
          className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors"
        >
          <div className="w-6 h-6 bg-gray-800 rounded-full flex items-center justify-center">
            <FiPlus
              size={14}
              className="text-white"
            />
          </div>
          <span className="text-sm font-medium">Add new level</span>
        </button>

        <div className="flex justify-center pt-8">
          <SimpleButton
            onClick={handleCreateChart}
            className="px-8 py-3 bg-[#1234CD] text-white font-medium rounded-xl hover:bg-blue-700 transition-colors"
          >
            Create Chart
          </SimpleButton>
        </div>
      </div>
      <ImageModal
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <div className="">
          <div className=" flex justify-center items-center">
            <img
              className="w-24 h-24"
              src={handGesture}
              alt=""
            />
          </div>

          <div>
            <h2 className="text-black text-center text-3xl leading-[27px] font-bold mb-2">
              Chart Created
            </h2>
          </div>
          <p className="text-black text-center text-base">
            Great Job, your organizational chart has been created successfully.
            <span className=" text-[#334cba]">Click here</span>to view chart.
          </p>

          <div className="flex justify-center mt-10 items-center">
            <button
              onClick={closeModal}
              className=" text-white rounded-xl hover:bg-[#334cba] w-full h-12 bg-[#1234CD] "
            >
              Done
            </button>
          </div>
        </div>
      </ImageModal>
    </div>
  );
}
